export const styles = {
  copyInput: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: "10px",
  },
  input: {
    margin: "0 !important",
  },
  copyButton: {
    marginBottom: "10px",
  },
};
